import {
  Datagrid,
  Filter,
  List,
  SaveButton,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useTranslate,
  useRecordContext,
} from 'react-admin'

import { DialogForm } from '../components/DialogForm'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton {...props} />
  </Toolbar>
)

export const AccessEditDialog = (props) => {
  const translate = useTranslate()
  const record = useRecordContext()
  if (!record) return null

  return (
    <DialogForm
      title={translate('hs.compliance.access.title', {
        copro_code: record.copro_code,
      })}
      id={record.id}
    >
      <SimpleForm
        toolbar={<SaveOnlyToolbar />}
        resource="compliance/access"
        basePath="/"
      >
        <TextInput source="building_number" />
        <TextInput source="number_of_foors" />
        <TextInput source="access_code" />
        <TextInput source="vigik" />
      </SimpleForm>
    </DialogForm>
  )
}

const AccessListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

export const AccessList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<AccessListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <TextField source="building_number" />
      <TextField source="number_of_foors" />
      <TextField source="access_code" />
      <TextField source="vigik" />
      <AccessEditDialog {...props} />
    </Datagrid>
  </List>
)
